import { LibConfig } from "../../init";
export var getSportRequest = function () {
    return {
        eventState: LibConfig.eventState
    };
};
//# sourceMappingURL=getSportRequest.js.map